// Re-exported from @ups/xplat/api/dto to break the circular dependency
// between @ups/xplat/api/dto and @ups/tool-tracker — `WarehouseInventory`
// in dto used to import this class from tool-tracker, which was the wrong
// direction (dto is a base lib, tool-tracker is a domain lib above it).
// The canonical definition now lives in
// libs/xplat/api/dto/src/lib/viewpoint-api/IInventoryCounter.ts, and this
// barrel re-export preserves backward compatibility for every consumer
// that imports `IInventoryCounter` from `@ups/tool-tracker`.
export { IInventoryCounter } from '@ups/xplat/api/dto';
